// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__3wrNQ","label":"Category_label__4iIuE","content":"Category_content__1E5ki","header":"Category_header__3LurE","location":"Category_location__rU6pP"};